export enum DiseaseMedicalEnum {
    Allergies = 1,
    Medications = 2,
    Immunization = 3
}